import { useMemo } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { format, isValid } from 'date-fns';
import { useIntl } from 'react-intl';
import { StyleSheet } from 'react-native';

import { CenteredRowContainer } from 'components/layout/centered-row-container';
import { selectors, useAppSelector } from 'state/global-state';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';
import { WEB_SMALL_MAX_WIDTH } from 'utils/constants';

import {
  CooldownMessageContainer,
  OffersCooldownContainer,
  OffersCooldownMessage,
  OffersCooldownTitle,
} from './loyalty-offers.styled';

export const LoyaltyOffersCooldownContent = () => {
  const { formatMessage } = useIntl();
  const { loyaltyUser } = useLoyaltyUser();

  const availableAfterTime = useMemo(() => {
    const { availableAfter } = loyaltyUser?.offerRedemptionAvailability || {};
    const availableAfterDate = availableAfter && new Date(availableAfter);
    return (
      availableAfterDate && isValid(availableAfterDate) && format(availableAfterDate, 'hh:mm a')
    );
  }, [loyaltyUser?.offerRedemptionAvailability]);

  return (
    <>
      <Icon variant="errorFill" size="14" marginRight="$2" />
      <CooldownMessageContainer>
        <OffersCooldownTitle>{formatMessage({ id: 'offersCooldownTitle' })}</OffersCooldownTitle>
        <OffersCooldownMessage>
          {availableAfterTime
            ? formatMessage({ id: 'offersAvailableAt' }, { time: availableAfterTime })
            : formatMessage({ id: 'offersAvailableAtFallback' })}
        </OffersCooldownMessage>
      </CooldownMessageContainer>
    </>
  );
};

export const LoyaltyOffersCooldownMessage = () => {
  const loyaltyOffersInCooldown = useAppSelector(selectors.loyalty.selectLoyaltyOffersInCooldown);

  if (!loyaltyOffersInCooldown) {
    return null;
  }

  return (
    <OffersCooldownContainer>
      <CenteredRowContainer style={styles.containerStyle} standardPadding>
        <LoyaltyOffersCooldownContent />
      </CenteredRowContainer>
    </OffersCooldownContainer>
  );
};

const styles = StyleSheet.create({
  containerStyle: { maxWidth: WEB_SMALL_MAX_WIDTH, flexDirection: 'row', alignItems: 'center' },
});
